import { render, staticRenderFns } from "./guiadidactica.vue?vue&type=template&id=6d48cf52"
import script from "./guiadidactica.vue?vue&type=script&lang=js"
export * from "./guiadidactica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports